export default __webpack_public_path__ + "static/5-15138cccbd32545a2f7b418581c3079f.webp";